import { useFirestore } from "@/hooks/firestore/core/useFirestore";
import { campaign } from "@/hooks/firestore/models/campaign";
import { useMemo } from "react";
import type { Always } from "@/types/utilities";

const useCampaigns = () => {
  const {
    isLoading,
    data: codes,
    error,
  } = useFirestore(`/users/{userId}/campaigns`, campaign.array(), {
    keyPath: "id",
  });

  const filteredCodes = useMemo(
    () => (codes || []).filter((code) => code.active).map((code) => code.id),
    [codes, isLoading],
  );

  return { codes: filteredCodes, error, isLoading };
};

type CampaignCodes = Always<ReturnType<typeof useCampaigns>["codes"]>;

export { useCampaigns };
export type { CampaignCodes };
